var isElementHidden = function isElementHidden(element) {
  if (getComputedStyle(element).visibility === 'hidden') {
    return true;
  }

  var ancestorSearchNode = element;

  while (ancestorSearchNode) {
    if (getComputedStyle(ancestorSearchNode).display === 'none') {
      return true;
    }

    ancestorSearchNode = ancestorSearchNode.parentElement;
  }

  return false;
};

export default isElementHidden;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/utils/dist/esm/isElementHidden/index.js
// module id = 556
// module chunks = 12